(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');

    // controller for tasks info
    module.controller('ItemDeactivatingController', ['$uibModalInstance',  ItemDeactivatingControllerFn]);

    function ItemDeactivatingControllerFn($uibModalInstance) {
        var vm = this;

        // cancel
        vm.no = function () {
            $uibModalInstance.dismiss();
        };

        // ok
        vm.yes = function () {
            $uibModalInstance.close();
        };      

    }

})();